import { render, staticRenderFns } from "./AccountHolder.vue?vue&type=template&id=0c5d68fd&scoped=true&"
import script from "./AccountHolder.vue?vue&type=script&lang=js&"
export * from "./AccountHolder.vue?vue&type=script&lang=js&"
import style0 from "./AccountHolder.vue?vue&type=style&index=0&id=0c5d68fd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5d68fd",
  null
  
)

export default component.exports